/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vignette } from '../../models/vignette';
import { VignettesForPeriodParams } from '../../models/vignettes-for-period-params';

export interface Vignettesforperiod$Params {
      body: VignettesForPeriodParams
}

export function vignettesforperiod(http: HttpClient, rootUrl: string, params: Vignettesforperiod$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Vignette;
}>> {
  const rb = new RequestBuilder(rootUrl, vignettesforperiod.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      [key: string]: Vignette;
      }>;
    })
  );
}

vignettesforperiod.PATH = '/vignettesforperiod';
